import React from 'react';

const humpSegmentRegex = /([A-Z][a-z]+)/;

export const SensiblyBreakCamelCase = ({
  camelCasedString,
}: {
  camelCasedString: string;
}) => {
  return (
    <>
      {camelCasedString
        .split(humpSegmentRegex)
        .filter((x) => x !== '')
        .flatMap((x, i) => (i === 0 ? x : [x, <wbr key={`${x}${i}`} />]))}
    </>
  );
};
